/* Product Tabs */
  $(document).ready(function() {
   
    const urlParams = new URLSearchParams(window.location.search);
    const hasInstallParam = urlParams?urlParams.has('installation'):false;

    $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      var activeLink;
      
      links.each(function () {
          if (!activeLink || (hasInstallParam && this.textContent.trim() === "Installation")){
            console.log(`Found Installation Anchor ${this}`); 
            activeLink = this;
          }
      });
      
      active = $(activeLink).addClass('active');
      content = $(active.attr('href'));

      console.log(`Active Link ${activeLink}`); 
      links.each(function () {
        console.log(`Current ${this}`); 
        if (this!=activeLink){
            console.log(`Hiding ${this}`); 
           $($(this).attr('href')).hide();
        }
      });

      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  });
/* End Product Tabs */